import React, { useContext } from 'react';
import Button from '@mui/material/Button';
import Menu from '@mui/material/Menu';
import MenuItem from '@mui/material/MenuItem';
//import KeyboardArrowDownIcon from '@mui/icons-material/KeyboardArrowDown';
import { ActionsIcon } from '../Icons'
import commonTranslations from '../languages/common.json';
import { LanguageContext } from '../context/LanguageContext';


export const SelectActionsMenu = ({ actions, params }) => {
    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);
    const { lang } = useContext(LanguageContext);
    const t = commonTranslations[lang].common.SelectActionsMenu;
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (
        <div style={{ height: '32px', display: 'flex', flexDirection: 'row' }}>
            <Button style={{ display: 'flex' }}
                id="selected-button"
                aria-controls={open ? 'selected-menu' : undefined}
                aria-haspopup="true"
                aria-expanded={open ? 'true' : undefined}
                variant="contained"
                disableElevation
                onClick={handleClick}
                endIcon={<ActionsIcon />}
            >
                {t.selected}
            </Button>
            <Menu
                id="selected-menu"
                MenuListProps={{ 'aria-labelledby': 'selected-button' }}
                anchorEl={anchorEl}
                open={open}
                onClose={handleClose}
            >
                {actions && actions.map((action, idx) => (
                    <MenuItem key={idx} id={idx} onClick={() => action.action(params)} disableRipple >
                        {action?.icon}
                        {action?.title}
                    </MenuItem>
                ))
                }
            </Menu>
        </div>
    )
}